export const getImageSrc = (image: string): string => {
    if (image === '' || image.trim() === '') return image;
    
    if (Buffer.from(image, 'base64').toString('base64') === image) return `data:image/png;base64,${image}`
    return image;
};